import * as Joi from 'joi';
import { MetricEditingState } from '../../components/futureSecurity/editMetric';

export const ragSchema = Joi.object({
  code: Joi.string().optional(),
  airport: Joi.string().optional(),
  groupType: Joi.string().valid("cell", "lane"),
  name: Joi.string().optional(),
  value1: Joi.number().required(),
  value2: Joi.number().when('comparator', {
    is: Joi.string().valid('RG', 'GR'),
    then: Joi.forbidden().messages({
      'any.unknown': 'value2 must not be defined for RG or GR comparators'
    }),
    otherwise: Joi.number().required()
  }),
  comparator: Joi.string()
    .valid('RAG', 'RG', 'GR', 'GAR')
    .required(),
  fromDate: Joi.date().iso(),
  toDate: Joi.date().iso().when('fromDate', {
    is: Joi.exist(),
    then: Joi.date().min(Joi.ref('fromDate')).messages({
      'date.min': 'To date must be after or equal to from date'
    })
  }),
  fromTime: Joi.string(),
  toTime: Joi.string(),
  isDefault: Joi.boolean().optional()
}).custom((obj, helpers) => {
  // Existing RAG and GAR validation
  if (["GAR", "RAG"].includes(obj.comparator) && obj.value1 >= obj.value2) {
    return helpers.message({
      custom: `This target is ${obj.comparator}, so the first value must be less than the second.`
    });
  }
  if(obj.isDefault) return obj // no need to check date time for default options
  // Date-time validation
  if (obj.fromDate && obj.toDate && obj.fromTime !== null && obj.fromTime >= 0 && obj.toTime !== null && obj.toTime >= 0) { // check the 0s on this
    // Convert Date objects to YYYY-MM-DD format
    const fromDateStr = obj.fromDate instanceof Date ? obj.fromDate.toISOString().split('T')[0] : obj.fromDate;
    const toDateStr = obj.toDate instanceof Date ? obj.toDate.toISOString().split('T')[0] : obj.toDate;
    
    
    const fromDateTime = new Date(`${fromDateStr}T${obj.fromTime}:00:00.000Z`).toISOString();
    const toDateTime = new Date(`${toDateStr}T${obj.toTime}:00:00.000Z`).toISOString();

    const now = new Date().toISOString()

    if(fromDateTime < now) {
      return helpers.message({
        custom: 'The target "from" time must be in the future.'
      })
    }
    if(toDateTime < now) {
      return helpers.message({
        custom: 'The target "to" time must be in the future.'
      })
    }
    if ((fromDateTime < toDateTime) === false) {
      return helpers.message({
        custom: 'The "from" date/time must be before the "to" date/time'
      });
    }
    if ((fromDateTime < toDateTime) === false) {
      return helpers.message({
        custom: 'The "from" date/time must be before the "to" date/time'
      });
    }
  }

  return obj;
});

export const validateRAGSchema = (metric: MetricDefinition, newValues: MetricEditingState, isFallback: boolean = false) => {
  console.log(metric, newValues)
  const combinedMetric: any = { 
    ...metric, 
    value1: newValues.value1, 
    value2: newValues.value2, 
    fromTime: newValues.fromTime,
    toTime: newValues.toTime,
    fromDate: newValues.fromDate,
    toDate: newValues.toDate,
    isDefault: isFallback
   };

  const { error } = ragSchema.validate(combinedMetric, { abortEarly: false });
  console.log(error)
  return error;
}

export const approvalNotesSchema = Joi.string().min(3).required();